import { FC, PropsWithChildren, forwardRef } from 'react';

import { SelectorButton } from '../SelectorButton/SelectorButton';
import { useSelectorPresenter } from './Selector.presenter';
import { ISelectorProps } from './Selector.types';
import { SelectorMenu } from './SelectorMenu/SelectorMenu';

export const Selector: FC<PropsWithChildren<ISelectorProps>> = forwardRef((props, _ref) => {
  const {
    className,
    isDisabled,
    theme = 'standard',
    Icon,
    label,
    items,
    onChange,
    value,
    isFullWidth,
    placement,
    emptyLabel,
    dataTest,
  } = props;

  const { presenter, buttonRef } = useSelectorPresenter({
    isDisabled,
    onChange,
    value,
    items,
    emptyLabel,
  });

  return (
    <>
      <SelectorButton
        className={className}
        title={presenter.buttonLabel}
        onClick={presenter.toggleIsOpened}
        isDisabled={isDisabled}
        isActive={presenter.isOpened}
        label={label}
        setRef={buttonRef}
        theme={theme}
        Icon={Icon}
        dataTest={dataTest}
      />
      <SelectorMenu
        isOpened={presenter.isOpened}
        reference={buttonRef.current}
        onClose={presenter.onClose}
        menuItems={presenter.menuItems}
        isFullWidth={isFullWidth}
        placement={placement}
      />
    </>
  );
});
